@if (isLoading()) {
<div id="initialLoading" class="uscb-transparent-button">
    Please wait. Loading... &nbsp;&nbsp; <i class="fa fa-spinner fa-spin fa-lg"></i>
</div>
}
